import React from "react";
import { Select, Button, Form, Flex, Divider } from "antd";

const { Option } = Select;

const CruiseRoomCard = ({ image, title, price, isHighlighted }) => {
  const [form] = Form.useForm();

  return (
    <div
      className={`flex rounded-xl overflow-hidden shadow-sm border ${
        isHighlighted ? "bg-[#f5f7ff]" : "bg-white"
      } mb-4`}
    >
      {/* Image */}
      <div className="p-4 pr-0 w-1/4">
        <div className="relative w-full h-full rounded-md overflow-hidden">
            <div className="absolute w-full h-full top-0 left-0 bg-[linear-gradient(180deg,_rgba(3,27,118,0)_39.42%,_#031B76_100%)]"></div>
          <img src={image} alt={title} className="w-full h-full object-cover" />
          <div className="absolute bottom-0 left-0 right-0  text-white text-[13px] font-medium px-2 py-1">
            {title}
          </div>
        </div>
      </div>

      {/* Form Fields */}
      <Form form={form} layout="vertical" className="filterForm w-1/2 py-4">
        {/* Column 1 */}
        <Flex className="flex-1 grid grid-cols-3 gap-4 pl-4 ">
          <Form.Item
            name="sailDate"
            label={<span className="text-xs font-medium">Sail Date</span>}
            className="col-span-2 mb-2"
          >
            <Select placeholder="Destination (Any)" className="w-full">
              <Option value="dubai">Dubai</Option>
              <Option value="abu-dhabi">Abu Dhabi</Option>
            </Select>
          </Form.Item>
          <Form.Item
            name="kid"
            label={<span className="text-xs font-medium">Kid</span>}
            className="col-span-1 mb-2"
          >
            <Select placeholder="Select Kid" className="w-full">
              <Option value="0">0</Option>
              <Option value="1">1</Option>
              <Option value="2">2</Option>
            </Select>
          </Form.Item>
        </Flex>

        {/* Column 2 */}
        <div className="flex-1 grid grid-cols-3 gap-4 pl-4">
          <Form.Item
            name="adult"
            label={<span className="text-xs font-medium">Adult</span>}
            className="mb-0"
          >
            <Select placeholder="Select Adult" className="w-full">
              <Option value="1">1</Option>
              <Option value="2">2</Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="teen"
            label={<span className="text-xs font-medium">Teen</span>}
            className="mb-0"
          >
            <Select placeholder="Select Teen" className="w-full">
              <Option value="0">0</Option>
              <Option value="1">1</Option>
              <Option value="2">2</Option>
            </Select>
          </Form.Item>

          {/* Column 3 */}
          <Form.Item
            name="infant"
            label={<span className="text-xs font-medium">Infant</span>}
            className="mb-0"
          >
            <Select placeholder="Select Infant" className="w-full">
              <Option value="0">0</Option>
              <Option value="1">1</Option>
            </Select>
          </Form.Item>
        </div>
      </Form>
      <div className="w-px bg-[#C0C0C0]/20 mx-4 self-stretch"></div>
      {/* Right Side: Price and Button */}
      <div className="flex flex-col justify-between w-1/4 py-4 pr-4">
        <div className="">
          <div className="text-xs font-medium">Total Amount</div>
          <div className="text-blue-800 font-bold text-lg">AED {price}</div>
        </div>

        <Button
          onClick={() => {
            form
              .validateFields()
              .then((values) => {
                
                // Add enquiry logic here
              })
              .catch((errorInfo) => {
                
              });
          }}
          type="danger"
          size="middle"
          className="w-full py-3 h-auto mt-4 font-medium text-sm rounded-tl-[12px] 
                rounded-bl-none rounded-tr-none rounded-br-[12px] bg-danger hover:bg-red-700 border-none rounded-md
                 text-white"
        >
          Book Now
        </Button>
      </div>
    </div>
  );
};

export default CruiseRoomCard;
